import React, {useState,useContext} from "react";
import { AppContext } from "../../AppContext";
import DatePicker from "react-datepicker";

import PoliticalFormDonateDefault from "./PoliticalFormDonateDefault";
import PoliticalFormDonateJwcole from "./PoliticalFormDonateJwcole";

const PoliticalFormDonate = (props)=>{
    
  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;
  
    return (
        <>
            { isJwCole 
                ? <PoliticalFormDonateJwcole editorMode={props.editorMode} data={props.data} validation={props.validation} handleChange={props.handleChange} handleDateChange={props.handleDateChange}/>
                : <PoliticalFormDonateDefault editorMode={props.editorMode} data={props.data} validation={props.validation} handleChange={props.handleChange} handleDateChange={props.handleDateChange}/>
            }  

        </>
    )

};

export default PoliticalFormDonate;